import { React, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosapi from "../api/axiosapi";
import useAuth from '../hooks/useAuth';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import { Helmet } from 'react-helmet-async';


const DoorCategory = ()=> {
    const {categoryDoorURL}=useParams();
    const navigateto = useNavigate();
    const {auth, setAuth} = useAuth();
    const [categoryInfo, setCategoryInfo] = useState('');
    const [categoryStory, setCategoryStory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect (() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const getCategoryInfo = async () => {
            try {
                const response = await axiosapi.get('/door/category/', {
                    params: {
                        url: categoryDoorURL
                    },
                    withCredentials: true
                })
                response.data && setCategoryInfo(response.data);
                const categoryStoryD = response.data && response.data.categoryStory && response.data.categoryStory.split("|");
                setCategoryStory(categoryStoryD);
            } catch (err) {
                console.log(err);
            }
        }
        getCategoryInfo();
    }, [categoryDoorURL])

    categoryInfo.categoryTitle && navigateto(`/door/category/problem/`, {state:{
            "categoryURL": categoryDoorURL,
            "problemCode": categoryInfo.firstProblemCode,
            "categoryTitle": categoryInfo.categoryTitle
        }});

    // const splitContent = (sentence) => {
    //     const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    //     const matches = sentence.matchAll(InlineMathRegex);
    //     let lastIndex = 0;
    //     const contentArray = [];
      
    //     for (const match of matches) {
    //         const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
    //         const restOfContent = sentence.substring(lastIndex, match.index);
        
    //         contentArray.push(restOfContent, InlineMathContent);
    //         lastIndex = match.index + match[0].length;
    //     }
      
    //     if (lastIndex < sentence.length) {
    //         contentArray.push(sentence.substring(lastIndex));
    //     }
      
    //     return <div>{contentArray}</div>;
    // };

    // return(
    //     <div className="App-full-container" key={categoryDoorURL}>
    //         <Helmet>
    //             <title>{categoryInfo.categoryTitle && "티프매쓰: "+categoryInfo.categoryTitle}</title>
    //             <meta name="description" content={categoryInfo.categoryDescription  && categoryInfo.categoryDescription} />
    //             <meta property="og:title" content={categoryInfo.categoryTitle && categoryInfo.categoryTitle} />
    //             <meta property="og:description" content={categoryInfo.categoryDescription  && categoryInfo.categoryDescription} />
    //             <meta property="og:url" content={"https://tiffmath.com/door/category/"+categoryDoorURL} />
    //             <meta property="og:type" content="website" />
    //             <meta property="og:image" content={"https://tiffmath.com/image/"+categoryInfo.categoryImage} />
    //         </Helmet>
    //         <div className="position-center-box-2-1">
    //             <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>{categoryInfo.categoryTitle}</h5>

    //             {<div style={{marginLeft:"5px"}}>
    //                 {categoryInfo.categoryDescription  && splitContent(categoryInfo.categoryDescription)}

    //             </div>}
                
    //             <div style={{marginLeft:"5px"}}>
    //                 {categoryInfo.categoryStory && <button 
    //                     className='button' 
    //                     onClick={() => navigateto(`/door/category/problem/`, {state:{
    //                         "categoryURL": categoryDoorURL,
    //                         "problemCode": categoryInfo.firstProblemCode,
    //                         "categoryTitle": categoryInfo.categoryTitle
    //                     }})}
    //                 >
    //                     문제 풀어보기
    //                 </button>}
    //                 {categoryInfo.categoryStory && <div>
    //                     <br/>
    //                     <br/>
    //                 </div>}

    //                 {/* <p style={{marginLeft:"5px"}}>{categoryInfo.publicationDate}</p> */}

    //                 {categoryInfo.categoryStory && categoryInfo.categoryStoryTitle && <b><p>{splitContent(categoryInfo.categoryStoryTitle)}</p></b>}

    //                 {categoryInfo.categoryImage && <img src={`/image/${categoryInfo.categoryImage}`} style={{width:'95%', marginBottom:'10px'}} />}
    //                 <br/>                
    //                 {categoryInfo.categoryStory && categoryStory.map(item => (<div><p>{splitContent(item)}</p></div>))}

    //                 <button 
    //                     className='button' 
    //                     onClick={() => navigateto(`/door/category/problem/`, {state:{
    //                         "categoryURL": categoryDoorURL,
    //                         "problemCode": categoryInfo.firstProblemCode,
    //                         "categoryTitle": categoryInfo.categoryTitle
    //                     }})}
    //                 >
    //                     문제 풀어보기
    //                 </button>
    //             </div>
    //         </div>
    //     </div>
    // );
};

export default DoorCategory;
